module.exports = __webpack_public_path__ + "static/media/templates.d003ff38.svg";